import { ActorType } from "./ActorType";
import BaseModel from "./BaseModel";

export enum WalletOperation {
    add = "add",
    withdraw = "withdraw"
}

export class WalletActor extends BaseModel {
    accountId?: number;
    tspId?: number;
    name: string;
    type: ActorType;

    constructor(data) {
        super(data, []);
        this.accountId = data.accountId;
        this.tspId = data.tspId;
        this.name = data.name;
        this.type = data.type as ActorType;
    }
}

export class WalletTransaction extends BaseModel {
    ownerAccountId: number;
    operation: WalletOperation;
    amountCents: number; // integer
    actor: WalletActor;
    message?: string;

    constructor(data) {
        super(data, []);
        this.ownerAccountId = data.ownerAccountId;
        this.operation = data.operation as WalletOperation;
        this.amountCents = data.amountCents;
        this.actor = data.actor;
        this.message = data.message;
    }
}

export class WalletTransactionListItem extends BaseModel {
    transactionId: string;
    date: Date;
    actor: WalletActor;
    message?: string;
    operation: WalletOperation;
    amountCents: number; // integer
    expireDatetime: Date|null;

    static __dates = ["date", "expireDatetime"];

    constructor(data) {
        super(data, WalletTransactionListItem.__dates);
        this.id = 0; // dummy to make GenericTable not throw errors
        this.transactionId = data.id;
        this.date = new Date(data.date);
        this.actor = new WalletActor(data.actor);
        this.message = data.message;
        this.operation = data.operation as WalletOperation;
        this.amountCents = data.amountCents;
        this.expireDatetime = data.expireDatetime ? new Date(data.expireDatetime) : null;
    }
}